import { parseDuration } from "../../../Services/helpers";
import { month, dayOfMonth } from "../../../Components/Formatting/DateTime";

const formatTooltipLabel = (tooltipItem, data, dataType) => {
    const value = parseInt(tooltipItem.raw);

    if (dataType === 'currency') {
        return tooltipItem.dataset.label+': £' + (value/100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    if (dataType === 'time') {
        const val = formatTime(value);

        return tooltipItem.dataset.label+': ' + val;
    }

    return tooltipItem.yLabel;
}

const tickCallback = (value, index, values, dataType) => {
    if (dataType === 'currency') {
        return '£ ' + (value/100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    }

    if (dataType === 'time') {
        return formatTime(value);
    }

    // Avoid showing fractions
    if (value !== Math.floor(value)) {
        return null;
    }

    return value;
}

const formatTime = (value) => {
    const {hours, minutes} = parseDuration(value);

    return [
        hours ? hours + 'h' : '',
        minutes + 'm',
    ].join(' ');
}

const getDateLabel = (date) => {
    if (typeof date === 'number') {
        return date;
    }

    const parts = date.split('-');

    // Months (2023-02)
    if (parts.length === 2 && parts[1].length === 2) {
        return month(parseInt(parts[1]), true);
    }

    // Weeks (2023-W02)
    if (parts.length === 2 && parts[1].length === 3) {
        return parts[1].replace('W', 'Week ');
    }

    // Days (2023-02-01)
    if (parts.length === 3) {
        return dayOfMonth(parts[2]) + ' ' + month(parseInt(parts[1]), false, true);
    }

    return date;
}

export {
    formatTooltipLabel,
    tickCallback,
    formatTime,
    getDateLabel,
}
